/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SpeciesDiagnosesMappedDto } from '../../models/species-diagnoses-mapped-dto';

export interface GetDiagnoses$Params {

/**
 * Key to select species. Could be in the format x.y, but here are just first two values extracted.
 */
  speciesKey?: string;
}

export function getDiagnoses(http: HttpClient, rootUrl: string, params?: GetDiagnoses$Params, context?: HttpContext): Observable<StrictHttpResponse<SpeciesDiagnosesMappedDto>> {
  const rb = new RequestBuilder(rootUrl, getDiagnoses.PATH, 'get');
  if (params) {
    rb.query('speciesKey', params.speciesKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SpeciesDiagnosesMappedDto>;
    })
  );
}

getDiagnoses.PATH = '/api/values/hex/diagnoses';
